export default class Currency {
  id: string;

  name: string;

  description: string;

  symbol: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.symbol = obj.symbol || '';
  }

  public static of(obj: any): Currency {
    return new Currency(obj || {});
  }

  public static ofList(obj: any[]): Currency[] {
    return obj.map(this.of);
  }
}
